// External Libraries
import * as React from 'react';
import { Avatar, Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';

// Fake testimonial data
const testimonials = [
    {
        name: 'Leslie Anne',
        title: 'IBDP Coordinator',
        quote: "If my school didn't fund this I would pay for it myself, it is brilliant. Also teachers invigilating love it as well as there is always worry about missing a 30 minute or 5 minute warning",
        avatar: '/static/images/avatar/1.jpg', // Placeholder avatar path
    },
    {
        name: 'Anne-Marie',
        title: 'IBDP Coordinator',
        quote: 'This is the BEST thing I bought as a DP Coordinator last year it is amazing and made my life so much easier when running 4 different exam rooms, three of which were for students with individual exam accomodations and hence had up to 5 different timers going per room. JUST AMAZING!!!!',
        avatar: '/static/images/avatar/2.jpg', // Placeholder avatar path
    },
    {
        name: 'Steven',
        title: 'IBDP Coordinator',
        quote: "I'm loving this site! It's worth the subscription price for the amount of time it has saved me in prepping for this session!",
        avatar: '/static/images/avatar/3.jpg', // Placeholder avatar path
    },
];

export default function Testimonials() {
    return (
        <Box
            sx={{
                bgcolor: 'background.default', // Use theme's default background
                py: 6, // Add vertical padding
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    component="h1"
                    variant="h2"
                    align="center"
                    color="text.primary"
                    gutterBottom
                    sx={{
                        fontSize: {
                            lg: '3.5rem', // Slightly adjust font sizes
                            md: '3rem',
                            sm: '2.5rem',
                            xs: '2rem'
                        },
                        mb: 3 // Add margin below title
                    }}
                >
                    What Our Users Say
                </Typography>
                <Grid container spacing={4} justifyContent="center">
                    {testimonials.map((testimonial) => (
                        <Grid item key={testimonial.name} xs={12} sm={6} md={4}>
                            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', boxShadow: 3 }}>
                                <CardContent sx={{ flexGrow: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                        <Avatar alt={testimonial.name} src={testimonial.avatar} sx={{ mr: 2 }} />
                                        <Box>
                                            <Typography variant="h6" component="div">
                                                {testimonial.name}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {testimonial.title}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
                                        "{testimonial.quote}"
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
}
